import React from 'react';
import styled from 'styled-components';

import CheckSVG from '@Assets/Svgs/ic_check.svg';

const ProjectImage = ({ image, onClick, isChecked }) => {
  return (
    <Container image={image} onClick={onClick}>
      {isChecked && <CheckImage />}
    </Container>
  );
};

const Container = styled.div`
  display: inline-block;
  width: 165px;
  height: 120px;
  background-color: ${({ theme }) => theme.colors.ui_on_4};
  background: url(${props => props.image}) no-repeat center;
  background-size: cover;
  margin-right: 11px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  cursor: pointer;

  &:last-child {
    margin-right: 20px;
  }
`;

const CheckImage = styled.img.attrs({ src: CheckSVG, alt: '선택됨' })`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 6px;
  left: 6px;
`;

export default ProjectImage;
